export default class ListEmployeeController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    employees
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.employees = employees;
  }

  edit() {
    this.$mdDialog.hide();
    this.$state.go('modules.settings.step1');
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
